var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 69,
    viewBox: "0 0 77 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 60.375C65.5 56.3627 65.5 54.3566 65.0048 52.7242C63.8899 49.0488 61.0137 46.1726 57.3383 45.0577C55.7059 44.5625 53.6997 44.5625 49.6875 44.5625H35.3125C31.3003 44.5625 29.2941 44.5625 27.6617 45.0577C23.9863 46.1726 21.1101 49.0488 19.9952 52.7242C19.5 54.3566 19.5 56.3627 19.5 60.375M55.4375 21.5625C55.4375 28.7077 49.6452 34.5 42.5 34.5C35.3548 34.5 29.5625 28.7077 29.5625 21.5625C29.5625 14.4173 35.3548 8.625 42.5 8.625C49.6452 8.625 55.4375 14.4173 55.4375 21.5625Z",
    stroke: "#147AF3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22H19M19 22L12 15M19 22L12 29",
    stroke: "#147AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignVector);
export default __webpack_public_path__ + "static/media/assignVector.15f8b7354232cf593518de12b14ce280.svg";
export { ForwardRef as ReactComponent };